/*!
  Machina, by Koding Themes
  sticky-menu.js
  https://kodingthemes.com
*/

document.addEventListener("DOMContentLoaded", function() {
  var elem = document.querySelector("#product-info");
  var stickyFormContainer = document.querySelector(".sticky-form-container");
  if (elem != null && stickyFormContainer != null) {
    ScrollTrigger.create({
      trigger: elem,
      start: 'top+=100% top',
      markers: false,
      onEnter: function() {
        stickyFormContainer.classList.add("sticky-form");
      },
      onEnterBack: function() {
        stickyFormContainer.classList.remove("sticky-form");
      }
    });
  }
});
